import { useEffect, useMemo, useState } from 'react'
import SectionTitle from '@ui/section-title'
import { Container } from '@ui/wrapper'
import Image from '@ui/image'
import SwiperSlider, { SwiperSlide } from '@ui/swiper'
import {
  ServicesWrapper,
  GridWrap,
  Grid,
  InnerSection,
  InfoCircle,
  InfoCircleText,
  ImageWrapper,
  ImageLink,
  SwiperWrapper
} from './style'
import Counter from '@components/counter/layout-05'
import { faPeopleRoof } from '@fortawesome/pro-light-svg-icons/faPeopleRoof'
import { faPeopleGroup } from '@fortawesome/pro-light-svg-icons/faPeopleGroup'
import { faLocationDot } from '@fortawesome/pro-light-svg-icons/faLocationDot'

const slider = {
  slidesPerView: 1,
  loop: true,
  speed: 1000,
  spaceBetween: 50,
  autoplay: {
    delay: 6000,
    disableOnInteraction: true
  },
  pagination: true,
  navigation: true,
  mousewheel: false,
  lazyPreloadPrevNext: 1
}

const HomeArea = ({ data, ...rest }) => {
  const [isPageLoaded, setIsPageLoaded] = useState(false)

  useEffect(() => {
    if (document.readyState === 'complete') {
      setIsPageLoaded(true)
    } else {
      const handleLoad = () => {
        setIsPageLoaded(true)
      }
      window.addEventListener('load', handleLoad)
      return () => {
        window.removeEventListener('load', handleLoad)
      }
    }
  }, [])

  return (
    <>
      {data?.texts[0] && isPageLoaded && (
        <div style={{ position: 'relative' }}>
          <InfoCircle to={data?.texts[0].path}>
            <InfoCircleText
              dangerouslySetInnerHTML={{ __html: data?.texts[0].content }}
            />
          </InfoCircle>
        </div>
      )}
      <ServicesWrapper {...rest}>
        <Container>
          {data?.section_title && (
            <SectionTitle
              mt="14px"
              title={data.section_title?.title}
              subtitle={data.section_title?.subtitle}
              description={data.section_title?.description}
            />
          )}
          <SwiperWrapper>
            <SwiperSlider
              options={slider}
              paginationTop="20px"
              opacityStyle
              waitForMount={false}
            >
              {useMemo(
                () =>
                  data.images?.map(
                    (image, index) =>
                      image.src && (
                        <SwiperSlide
                          className="item"
                          key={'image-' + index.toString()}
                        >
                          <ImageWrapper>
                            <ImageLink
                              to={image.path}
                              aria-label={
                                image.src.alternativeText || image.path || ''
                              }
                            >
                              <Image
                                loading={index === 0 ? 'eager' : 'lazy'}
                                src={image.src.localFile || image.src}
                                alt={image.src.alternativeText || ''}
                              />
                            </ImageLink>
                          </ImageWrapper>
                        </SwiperSlide>
                      )
                  ),
                [data.images]
              )}
            </SwiperSlider>
          </SwiperWrapper>
        </Container>
      </ServicesWrapper>
      <InnerSection {...rest}>
        <Container>
          <GridWrap>
            {data?.items?.map((item, index) => {
              const counterIcons = [faPeopleRoof, faPeopleGroup, faLocationDot]
              const counterIcon =
                index < counterIcons.length
                  ? counterIcons[index]
                  : counterIcons[0]

              return (
                <Grid key={item.id}>
                  <Counter
                    title={item.title}
                    countTo={item.count}
                    text={item.description}
                    icon={counterIcon}
                    path={item.path}
                  />
                </Grid>
              )
            })}
          </GridWrap>
        </Container>
      </InnerSection>
    </>
  )
}

export default HomeArea
